import {Component, NgZone, OnInit, Output, EventEmitter} from '@angular/core';
import { MapsAPILoader, GoogleMapsAPIWrapper, LatLngBounds } from '@agm/core';

declare var google: any;

@Component({
  selector: 'user-search-address',
  templateUrl: './search-address.component.html',
  styleUrls: ['./search-address.component.scss']
})

export class SearchAddressComponent implements OnInit {
    geocoder:any;
    address:string;

    constructor(public mapsApiLoader: MapsAPILoader,
                private zone: NgZone,
                private wrapper: GoogleMapsAPIWrapper) {
        this.mapsApiLoader = mapsApiLoader;
        this.zone = zone;
        this.wrapper = wrapper;
        this.mapsApiLoader.load().then(() => {
            this.geocoder = new google.maps.Geocoder();
        });
    }

    @Output() boundsChange = new EventEmitter<LatLngBounds>();
    myFunctionMyName(increased:LatLngBounds) {
        this.boundsChange.emit(increased);
    }

    ngOnInit() {

    }

    updateOnMap() {
        this.findLocation();
    }

    findLocation() {
        if (!this.geocoder) this.geocoder = new google.maps.Geocoder()
        this.geocoder.geocode({
            'address': this.address
        }, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[0].geometry.viewport) {
                    this.myFunctionMyName(results[0].geometry.viewport as LatLngBounds);
                }
            } else {
                alert("Sorry, this search produced no results.");
            }
        })
    }

    onKeydown(event) {
        if (event.key === "Enter") {
            this.findLocation();
        }
    }
}
